export function mmss(totalSeconds: number): string {
  const s = Math.max(0, Math.round(totalSeconds));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}

export function duration(seconds: number | null): string {
  if (seconds == null) return '-';
  if (seconds < 60) return `${Math.round(seconds)}s`;
  const m = Math.round(seconds / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}

/** "today", "yesterday", "3 days ago", "14 Jun". */
export function whenShort(iso: string, now = Date.now()): string {
  const then = new Date(iso);
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOfDay(new Date(now)) - startOfDay(then)) / 86_400_000);

  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days} days ago`;
  return then.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

/** Trailing zeros are noise on a 1.5 kg ladder: 17.5 but 20, not 20.0. */
export function kg(value: number | null | undefined): string {
  if (value == null) return '-';
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

export function loadLabel(value: number | null, unit: 'per_hand' | 'total' | 'none'): string {
  if (unit === 'none' || value == null) return '';
  return unit === 'per_hand' ? `${kg(value)} kg each hand` : `${kg(value)} kg`;
}
